import ApiUrl from "../../../configTools/api";
const User = JSON.parse(localStorage.getItem("user-info"));

const headers = () => ({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer '+User.token
});

// Mirrors labadminprints/label/function.js against the doctor endpoints - see the comments
// there for why the tooth data has to come from the job card call.
const GetHeader = (id) =>
    fetch(ApiUrl.DoctorPrint_Label_Order+"/"+id,{ method:'GET', headers: headers() })
        .then(res=>res.json())
        .then(data=>data.response);

const GetTeeth = (id) =>
    fetch(ApiUrl.DoctorPrint_Jobcard_Order+"/"+id,{ method:'GET', headers: headers() })
        .then(res=>res.json())
        .then(data=>(data.response && data.response.lineItems) || []);

const Get = (id,setValues) =>
    Promise.all([GetHeader(id), GetTeeth(id).catch(()=>[])])
        .then(([header, lineItems])=>{
            setValues(header ? {...header, lineItems} : null);
        });

const Functions = {Get};
export default Functions;
